// Outline variant of assets/icons/sheild.svg — normalized to 24×24 / stroke 2

const SHIELD_PATH =
  "M13.6486 4.95661C13.6297 4.51815 13.6297 4.09961 13.6297 3.68108C13.6297 3.34226 13.3834 3.08317 13.0614 3.08317C10.6932 3.08317 8.89349 2.36568 7.39685 0.831051C7.16951 0.611818 6.8285 0.611818 6.60116 0.831051C5.10452 2.36568 3.30476 3.08317 0.936655 3.08317C0.614593 3.08317 0.36831 3.34226 0.36831 3.68108C0.36831 4.09961 0.36831 4.51815 0.349365 4.95661C0.273586 9.14196 0.159916 14.8819 6.80956 17.2934L6.999 17.3333L7.18845 17.2934C13.8191 14.8819 13.7244 9.16189 13.6486 4.95661Z";

const SHIELD_SCALE = 24 / 18;
const SHIELD_OFFSET_X = (24 - 14 * SHIELD_SCALE) / 2;

const ShieldCheckOutlineIcon = ({
  size = 24,
  color = "#EF4444",
  strokeWidth = 2,
  className = "",
  ...props
}) => {
  const scaledStrokeWidth = strokeWidth / SHIELD_SCALE;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g transform={`translate(${SHIELD_OFFSET_X}, 0) scale(${SHIELD_SCALE})`}>
        <path
          d={SHIELD_PATH}
          stroke={color}
          strokeWidth={scaledStrokeWidth}
          strokeLinejoin="round"
        />
        <path
          d="M4 8.7L6.2 10.9L10 6.5"
          stroke={color}
          strokeWidth={scaledStrokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default ShieldCheckOutlineIcon;
